<template>
  <div class="sedna-slider-mini">
    <div class="slide-mini" v-for="(item, i) in items" :key="i" :class="i === activeSlide ? `active` : `inactive`">
      <h2>{{ item.title }}</h2>
      <div class="timestamp-mini">{{ item.timestamp }}</div>
      <div class="source-mini">{{ item.sourceTitle }}</div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'SliderMini',
    props: {
      items: Array,
    },
    data() {
      return {
        activeSlide: 0,
        timer: null,
      }
    },
    methods: {
      randomizeSlide: function () {
        const maxNumber = this.items.length
        this.activeSlide = Math.floor(Math.random() * Math.floor(maxNumber))
      }
    },
    mounted: function() {
      let timerDelay = 3;
      const urlQuery = new URLSearchParams(window.location.search)
      if (urlQuery.get("delay") !== null) {
        timerDelay = parseFloat(urlQuery.get("delay"))
      }

      this.randomizeSlide()
      this.timer = setInterval(this.randomizeSlide, timerDelay * 1000)
    },
    beforeDestroy: function () {
      clearInterval(this.timer)
    }
  }
</script>

<style>
  .sedna-slider-mini {
    position: relative;
    width: 100%;
    height: 280px;
  }
  .slide-mini {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    opacity: 0;
    transition: opacity .6s ease-in-out;
  }
  .slide-mini.active {
    opacity: 1;
    transition: opacity .6s ease-in-out;
  }
  .slide-mini .source-mini {
    position: absolute;
    bottom: 0;
    right: 0;
    font-size: 30px;
  }
  .slide-mini .timestamp-mini {
    position: absolute;
    bottom: 0;
    left: 0;
    font-size: 30px;
  }
  .aretv .slide-mini .source-mini {
    font-size: 32px;
    font-weight: 600;
  }
  .aretv .timestamp-mini {
    font-size: 32px;
  }
</style>
